__webpack_require__.p = "https://static.recollective.com/v1.6.13-010/_inc/dist/";